import type { Participant } from '@app/models'

export type ConversationActorRole =
  | 'private'
  | 'buyerOrRenter'
  | 'professional'

const BUYER_OR_RENTER_ROLES: Participant['role'][] = [
  'MainBuyerOrRenter',
  'BuyerOrRenter',
]

const AGENT_ROLES: Participant['role'][] = ['MainAgent', 'Agent']

export const getConversationActorRole = (
  participants: Participant[] | undefined,
  currentUserId: number | undefined,
  isB2B: boolean | undefined
): ConversationActorRole | undefined => {
  if (isB2B) {
    return 'professional'
  }

  if (!participants?.length || currentUserId == null) {
    return undefined
  }

  const currentUserParticipant = participants.find(
    (participant) => participant.userId === currentUserId
  )

  if (!currentUserParticipant) {
    return undefined
  }

  if (currentUserParticipant.isPrivateAdvertiser) {
    return 'private'
  }

  if (BUYER_OR_RENTER_ROLES.includes(currentUserParticipant.role)) {
    return 'buyerOrRenter'
  }

  if (
    AGENT_ROLES.includes(currentUserParticipant.role) ||
    currentUserParticipant.isAgent
  ) {
    return 'professional'
  }

  return undefined
}
